define(['jquery'], function($) {
	$('[data-role="accordion"] [data-bind="accordion-toggle"]').click(function(e) {
		e.preventDefault();

		var $parent = $(this).closest('[data-role="accordion"]');
		var $content = $('[data-bind="accordion-content"]', $parent);

		if($content.height() > 1) {
			$content.css('max-height', '0');
		} else {
			$content.css('max-height', '1000px');
		}
	});
});